import { ApolloProvider } from "@apollo/client/react";
import type { PropsWithChildren } from "react";
import { useApolloClient } from "./useApolloClient.tsx";

export const CalculabelApolloProvider = ({ children }: PropsWithChildren) => {
  const { apolloClient } = useApolloClient();
  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};
